(async () => {
  if (customElements.get('collection-slider')) {
    return;
  }

  const { default: Swiper, Navigation, Mousewheel } = await import('./swiper.esm-8fb044b1.async.js');

  Swiper.use([Navigation, Mousewheel]);

  const EDITABLE_SELECTOR = 'input, textarea, select, [contenteditable="true"]';

  class CollectionSlider extends HTMLElement {
    constructor() {
      super();

      this.swiperInstance = null;
      this.handleKeydown = this.handleKeydown.bind(this);
      this.updateArrowOffset = this.updateArrowOffset.bind(this);
    }

    connectedCallback() {
      this.viewport = this.querySelector('[data-collection-slider]');
      this.previousButton = this.querySelector('[data-collection-slider-prev]');
      this.nextButton = this.querySelector('[data-collection-slider-next]');

      this.addEventListener('keydown', this.handleKeydown);

      this.init();
    }

    disconnectedCallback() {
      this.removeEventListener('keydown', this.handleKeydown);

      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    init() {
      if (!this.viewport || this.swiperInstance) {
        return;
      }

      if (this.viewport.offsetWidth === 0) {
        return;
      }

      this.swiperInstance = new Swiper(this.viewport, this.buildOptions());

      this.updateArrowOffset();
    }

    refresh() {
      if (!this.swiperInstance) {
        this.init();
        return;
      }

      this.swiperInstance.update();
      this.updateArrowOffset();
    }

    buildOptions() {
      const defaults = {
        slidesPerView: 'auto',
        spaceBetween: 0,
        speed: 400,
        loop: false,
        autoplay: false,
        direction: 'horizontal',
        grabCursor: true,
        watchOverflow: true,
        threshold: 3,
        mousewheel: {
          forceToAxis: true,
          thresholdDelta: 6
        }
      };

      return {
        ...defaults,
        navigation: {
          prevEl: this.previousButton,
          nextEl: this.nextButton
        },
        on: {
          resize: this.updateArrowOffset
        }
      };
    }

    updateArrowOffset() {
      const media = this.querySelector('.swiper-slide .product-card__media');

      if (!media) {
        return;
      }

      const mediaRect = media.getBoundingClientRect();

      if (mediaRect.height === 0) {
        return;
      }

      const sliderRect = this.getBoundingClientRect();
      const offset = mediaRect.top - sliderRect.top + mediaRect.height / 2;

      this.style.setProperty('--slider-arrow-top', `${Math.round(offset)}px`);
    }

    handleKeydown(event) {
      if (!this.swiperInstance || event.defaultPrevented) {
        return;
      }

      if (event.target instanceof Element && event.target.closest(EDITABLE_SELECTOR)) {
        return;
      }

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.swiperInstance.slidePrev();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.swiperInstance.slideNext();
      }
    }
  }

  window.CollectionSlider = CollectionSlider;
  customElements.define('collection-slider', CollectionSlider);
})();
